<template>
  <v-container fluid>
    <div class="scheduled-posts-container custom-shadow">
      <div class="header">
        <div class="d-flex ga-2 align-center">
          <h2>{{ $t("Poststoday") }}</h2>
          <h4 v-if="soonestScheduleLabel" class="highlight">
            {{ soonestScheduleLabel }}
          </h4>
        </div>
        <v-btn variant="outlined" class="view-all"> {{ $t("Viewall") }} </v-btn>
      </div>

      <v-row class="mt-6">
        <!-- Data available state -->
        <template v-if="Scheduled && Scheduled.length > 0">
          <v-col
            cols="3"
            lg="3"
            md="4"
            sm="6"
            xs="12"
            v-for="(post, index) in Scheduled"
            :key="index"
          >
            <div class="p-2 card post-shadow">
              <!-- Post header -->
              <div class="card-header">
                <div class="user-image-container mr-2">
                  <img :src="post.page_profile_picture" class="user-avatar" />
                  <img :src="post.socialIcon" class="social-icon" />
                </div>
                <div class="text-group">
                  <div class="company-name">{{ post.page_name }}</div>
                  <div class="scheduled-time">
                    <span
                      >Scheduled at
                      {{ formatReadableDate(post.schedule_time) }}</span
                    >
                  </div>
                </div>
                <Dollar />
              </div>

              <!-- Post body -->
              <div class="card-body">
                <p class="description">{{ post.caption }}</p>
                <img
                  v-if="post?.media_file"
                  :src="post?.media_file"
                  class="post-image my-2"
                  alt="post image"
                />
                <img
                  v-else
                  src="@/assets/images/No-media-uploaded.svg"
                  class="post-image my-2"
                  alt="No media uploaded"
                />
              </div>

              <!-- Post footer -->
              <div class="card-footer">
                <v-btn
                  @click="previewPost(post.id)"
                  class="preview-btn flex-grow-1"
                  variant="outlined"
                >
                  Preview
                </v-btn>
                <button @click="editPost(post.id)" class="edite-post">
                  <Edithome />
                </button>
              </div>
            </div>
          </v-col>
        </template>

        <!-- No data state -->
        <template v-else>
          <v-col cols="12">
            <div class="d-flex justify-center align-center">
              <div class="text-center">
                <img
                  src="@/components/icons/activeadicons/no-account.png"
                  alt="no data"
                  class="mb-2"
                />
                <p>{{ $t("no_scheduled_post") }}</p>
              </div>
            </div>
          </v-col>
        </template>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Edithome from "@/components/icons/posts/Edithome.vue";
import Deletehome from "@/components/icons/posts/Deletehome.vue";
import Dollar from "@/components/icons/posts/Dollar.vue";

export default {
  name: "Scheduled",
  components: {
    Edithome,
    Deletehome,
    Dollar,
  },
  props: {
    Scheduled: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    soonestScheduleLabel() {
      if (!this.Scheduled || this.Scheduled.length === 0) {
        return "";
      }
      const soonest = this.Scheduled.reduce((earliest, post) => {
        if (!post?.schedule_time) return earliest;
        if (!earliest?.schedule_time) return post;
        return new Date(post.schedule_time.replace(" ", "T")) <
          new Date(earliest.schedule_time.replace(" ", "T"))
          ? post
          : earliest;
      }, null);
      return soonest?.schedule_time
        ? this.formatHeaderDate(soonest.schedule_time)
        : "";
    },
  },
  methods: {
    previewPost(postId) {
      localStorage.setItem("postId", postId);
      localStorage.removeItem("editePostId"); // ✅ احذف الأول
      this.$router.push({ name: "PublishPost" });
    },
    editPost(postId) {
      localStorage.setItem("editePostId", postId);
      localStorage.removeItem("postId"); // ✅ احذف الأول
      this.$router.push({ name: "PublishPost" });
    },

    // Format date from database to readable format
    formatReadableDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString.replace(" ", "T"));
      const day = ("0" + date.getDate()).slice(-2);
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },

    // Header highlight: soonest upcoming schedule (weekday + day + month)
    formatHeaderDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString.replace(" ", "T"));
      const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const weekday = weekdays[date.getDay()];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const suffix = this.getDaySuffix(day);
      return `${weekday} ${day}${suffix} ${month}`;
    },

    // Generate suffix for day
    getDaySuffix(day) {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
  },
};
</script>

<style scoped>
.scheduled-posts-container {
  padding: 2.3rem;
  background-color: #fff;
  border-radius: 12px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.header h2 {
  font-family: "Inter", sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
}
.header .highlight {
  color: #237276;
}
.user-image-container {
  position: relative;
  border-radius: 50%;
}

.user-avatar {
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
}

.social-icon {
  position: absolute;
  bottom: 4px;
  right: -5px;
  max-width: 40px;
  border-radius: 50%;
}
.view-all {
  font-size: 14px;
  padding: 6px 12px;
  border-color: #237276;
  color: #237276;
  text-transform: none;
  border-radius: 8px;
}

.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.card {
  background-color: #fff;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.card-header .logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.card-header .text-group {
  flex: 1;
}

.company-name {
  font-size: 16px;
  font-family: "Inter", sans-serif;
  color: #333333;
}

.scheduled-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #237276;
}

.boost-icon {
  width: 16px;
  height: 16px;
  margin-left: auto;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.description {
  font-size: 12px;
  color: #666666;
  line-height: 1.4;
  font-family: "Open Sans", sans-serif;
}

.post-image {
  border-radius: 12px;
  width: 100%;
  height: 18rem;
}

.card-footer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.preview-btn {
  font-size: 13px;
  padding: 4px 1rem;
  text-transform: none;
  border-color: #237276;
  color: #237276;
  border-radius: 8px;
}

.action-icon {
  font-size: 18px;
  color: #237276;
  cursor: pointer;
}
.custom-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);
}
.post-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08), 0px 0px 12px rgba(0, 0, 0, 0.08);
}
</style>
